export const initShare = () => {
  const buttonsShareOnDevice: NodeListOf<HTMLButtonElement> =
    document.querySelectorAll(".share-on-device");

  if (!buttonsShareOnDevice) {
    return;
  }

  buttonsShareOnDevice.forEach((buttonShareOnDevice) => {
    buttonShareOnDevice.addEventListener("click", () => {
      const shareData = {
        title: buttonShareOnDevice.dataset.shareTitle,
        text: buttonShareOnDevice.dataset.shareText,
        url: buttonShareOnDevice.dataset.shareUrl,
      };

      // Check if browser support Sharing
      if (navigator.canShare?.(shareData)) {
        try {
          navigator.share(shareData).catch(() => {
            // User cancelled the share sheet (AbortError). Mark the rejection as handled.
          });
        } catch (_err) {
          // Some browsers throw synchronously instead of rejecting. Nothing to do.
        }
        return;
      }

      let clipboardText = "";
      if (buttonShareOnDevice.dataset.shareTitle) {
        clipboardText = `${buttonShareOnDevice.dataset.shareTitle}: `;
      }
      if (buttonShareOnDevice.dataset.shareText) {
        clipboardText = `${clipboardText + buttonShareOnDevice.dataset.shareText} `;
      }
      if (buttonShareOnDevice.dataset.shareUrl) {
        clipboardText = clipboardText + buttonShareOnDevice.dataset.shareUrl;
      }

      navigator.clipboard.writeText(clipboardText.trim()).then(
        () => {
          /* clipboard successfully set */
          alert(buttonShareOnDevice.dataset.shareClipboardSuccessText);
        },
        () => {
          /* clipboard write failed */
          alert("Copying to clipboard failed. Please manually copy the text.");
        },
      );
    });
  });
};
